onInteractive(function() {
	// Header photos are cropped to fill their box, so the browser needs the rendered width of the whole photo to pick a sharp source.
	const coverPictures = document.querySelectorAll('.home-hero picture, .page-header picture');
	const updateSizes = function() {
		coverPictures.forEach(function(picture) {
			const image = picture.querySelector('img');
			if (!image || !image.getAttribute('width') || !image.getAttribute('height')) {
				return;
			}
			const box = image.getBoundingClientRect();
			const ratio = image.getAttribute('width') / image.getAttribute('height');
			// Slides that are not shown yet have no box; they get the size of the visible slide.
			const height = box.height || picture.closest('.carousel-inner').getBoundingClientRect().height;
			const width = Math.ceil(Math.max(box.width || window.innerWidth, height * ratio));
			picture.querySelectorAll('source, img').forEach(function(element) {
				element.setAttribute('sizes', width + 'px');
			});
		});
	};
	updateSizes();
	window.addEventListener('resize', updateSizes);
});

onComplete(function() {
	// The next slides of a header slider load lazily, so they would slide in as an empty dark box.
	// Once the page has loaded they are fetched in the background.
	document.querySelectorAll('.home-hero .carousel-item img[loading="lazy"], .page-header .carousel-item img[loading="lazy"]').forEach(function(image) {
		image.setAttribute('loading', 'eager');
	});
});
